export interface NotificationPreference {
    type: NotificationPreferenceType;
    channels: Channel[];
    sendStartTime?: number;
    sendEndTime?: number;
}

export enum NotificationPreferenceType {
    ORDER_CREATED_SELLER = "order_created_seller",
    ORDER_CONFIRMED_SELLER = "order_confirmed_seller",
    ORDER_CHANGED_SELLER = "order_changed_seller",
    ORDER_CANCELED_SELLER = "order_canceled_seller",
    ROSTER_SELLER = "roster_download_seller",
    PAYOUT_SELLER = "seller_payout",
    DEPOSIT_BALANCE_REMINDER_SELLER = "deposit_balance_reminder_to_seller",
    INVOICE_REMINDER_SELLER = "invoice_reminder_seller",
    GRATUITY_RECEIVED_SELLER = "gratuity_received_seller",
    WAITLIST_ADDED_SELLER = "waitlist_added_seller",
    GUIDE_ADDED = "guide_added",
    VIRTUAL_MEETING_STARTED_SELLER = "virtual_meeting_started_seller",
    WARE_LOW_INVENTORY_THRESHOLD_REACHED = "ware_low_inventory_threshold_reached",

    ORDER_CREATED_TRAVELER = "order_created_to_traveler",
    ORDER_CONFIRMED_TRAVELER = "order_confirmed_to_traveler",
    ORDER_CHANGED_TRAVELER = "order_changed_to_traveler",
    INVOICE_CHANGED_TRAVELER = "invoice_changed_traveler",
    ORDER_CANCELED_TRAVELER = "order_canceled_to_traveler",
    TRIP_REMINDER_TRAVELER = "trip_reminder_to_traveler",
    GIFT_REMINDER_TRAVELER = "gift_reminder_traveler",
    INVOICE_REMINDER_TRAVELER = "invoice_reminder_traveler",
    WAITLIST_INVITED_TRAVELER = "waitlist_invited_traveler",
    GRATUITY_REMINDER_TRAVELER = "gratuity_reminder_traveler",
    GRATUITY_RECEIVED_TRAVELER = "gratuity_received_traveler",
    WAITLIST_ADDED_TRAVELER = "waitlist_added_traveler",
    REVIEW_REMINDER_TRAVELER = "review_reminder_to_traveler",
    WAIVER_REMINDER_TRAVELER = "waiver_reminder_to_traveler",
    ABANDONED_RECOVERY_TRAVELER = "abandoned_recovery_to_traveler",
    VIRTUAL_MEETING_STARTED_TRAVELER = "virtual_meeting_started_traveler",
    PURCHASE_REVIEW_REMINDER_TRAVELER = "purchase_review_reminder_traveler",

    ROSTER_GUIDE = "roster_download_guide",
    GUIDE_REMINDER = "guide_reminder",
    GRATUITY_RECEIVED_GUIDE = "gratuity_received_guide",
    VIRTUAL_MEETING_STARTED_GUIDE = "virtual_meeting_started_guide",

    BEFORE = "before",
    AFTER = "after",
}

export interface Channel {
    enabled: boolean;
    negativeOffset: boolean;
    offset: string;
    type: ChannelType;
    readonly?: boolean;
}

export enum ChannelType {
    EMAIL = "email",
    SMS = "sms",
}

export const ChannelTypeCopy: Record<ChannelType, string> = {
    [ChannelType.EMAIL]: "Email",
    [ChannelType.SMS]: "SMS",
};

export const ChannelEmailDefaultOffsetMap: { [key: string]: string } = {
    [NotificationPreferenceType.DEPOSIT_BALANCE_REMINDER_SELLER]: "P2D",
    [NotificationPreferenceType.INVOICE_REMINDER_SELLER]: "P1D",
    [NotificationPreferenceType.ROSTER_SELLER]: "PT12H",
    [NotificationPreferenceType.ROSTER_GUIDE]: "PT12H",
    [NotificationPreferenceType.TRIP_REMINDER_TRAVELER]: "P1D",
    [NotificationPreferenceType.REVIEW_REMINDER_TRAVELER]: "P1D",
    [NotificationPreferenceType.INVOICE_REMINDER_TRAVELER]: "P1D",
    [NotificationPreferenceType.GRATUITY_REMINDER_TRAVELER]: "PT30M",
};
